// Mock data for SkyWay Green Platform

export const navigation = [
  { label: 'Home', href: '#home', children: null },
  { label: 'Partners', href: '#partners', children: [
    { label: 'Rewards', href: '#rewards' },
    { label: 'Structure', href: '#structure' },
  ]},
  { label: 'Investments', href: '#investments', children: [
    { label: 'Packages', href: '#packages' },
    { label: 'My Investments', href: '#my-investments' },
    { label: 'Installment Package', href: '#installment' },
    { label: 'My Certificates', href: '#certificates' },
  ]},
  { label: 'Portal Center', href: '#portal', children: [
    { label: 'Wallet', href: '#wallet' },
    { label: 'Deposit', href: '#deposit' },
    { label: 'Withdraw', href: '#withdraw' },
    { label: 'Transfer', href: '#transfer' },
    { label: 'Dividend', href: '#dividend' },
    { label: 'History', href: '#history' },
  ]},
  { label: 'Share Transfer', href: '#share-transfer' },
  { label: 'Profile', href: '#profile', children: [
    { label: 'KYC', href: '#kyc' },
    { label: 'Authentication', href: '#auth' },
    { label: 'Delivery Addresses', href: '#addresses' },
  ]},
  { label: 'News', href: '#news', children: [
    { label: 'Ecosystem News', href: '#ecosystem-news' },
  ]},
  { label: 'Setting', href: '#setting', children: [
    { label: 'Change Password', href: '#change-password' },
  ]},
];

export const pillars = [
  {
    id: 1,
    slug: 'skyway',
    title: 'SkyWay (String Transport)',
    description: 'Elevated eco-friendly passenger & cargo string rail transport',
  },
  {
    id: 2,
    slug: 'bridge',
    title: 'SkyWay Bridge',
    description: 'High-tech urban bypasses, innovative structural bridge links',
  },
  {
    id: 3,
    slug: 'ai-robot',
    title: 'Artificial Intelligence (AI) Robot',
    description: 'Autonomous machines learning, navigating, and assisting across smart cities',
  },
];

export const stats = [
  { value: '50+', label: 'Global Partners' },
  { value: '120K', label: 'Active Investors' },
  { value: '30+', label: 'Countries Reached' },
  { value: '$1.2B', label: 'Total Investment' },
];

export const features = [
  {
    id: 1,
    title: 'Zero Emissions',
    description: 'Fully electric elevated transport reduces CO₂ output by up to 90% versus traditional systems.',
    icon: 'Leaf',
  },
  {
    id: 2,
    title: 'String Rail Technology',
    description: 'Patented pre-stressed steel string tracks deliver unmatched stability at high speeds.',
    icon: 'Route',
  },
  {
    id: 3,
    title: 'Autonomous AI Drivers',
    description: 'Onboard AI robotics learn traffic, weather, and passenger flow in real-time.',
    icon: 'Bot',
  },
  {
    id: 4,
    title: 'Cinematic 3D Simulations',
    description: 'Preview full routes and stations through immersive photoreal 3D previews.',
    icon: 'Film',
  },
  {
    id: 5,
    title: 'Low Infrastructure Cost',
    description: 'Elevated design uses 3x less land and 5x less material than traditional rail.',
    icon: 'Building2',
  },
  {
    id: 6,
    title: 'Smart Cargo Delivery',
    description: 'Automated cargo pods run 24/7 with predictive routing to reduce delivery time.',
    icon: 'Package',
  },
];

export const investmentPackages = [
  {
    id: 1,
    name: 'Starter Green',
    price: 250,
    shares: 39000,
    monthly: 25,
    months: 10,
    deckId: 3,
    features: ['39,000 Share Units', 'Monthly $25 for 10 months'],
    popular: false,
  },
  {
    id: 2,
    name: 'Growth Green',
    price: 1500,
    shares: 280000,
    monthly: 150,
    months: 10,
    deckId: 10,
    features: ['280,000 Share Units', 'Monthly $150 for 10 months'],
    popular: true,
  },
  {
    id: 3,
    name: 'Elite Green',
    price: 5000,
    shares: 1050000,
    monthly: 500,
    months: 10,
    deckId: 7,
    features: ['1,050,000 Share Units', 'Monthly $500 for 10 months'],
    popular: false,
  },
];

export const news = [
  {
    id: 1,
    category: 'Announcement',
    date: 'Jul 12, 2025',
    title: 'SkyWay Green launches first commercial line in EcoCity',
    excerpt: 'The 42km elevated corridor is now operational, connecting five hubs across the eco district.',
    image: 'https://images.unsplash.com/photo-1645615094859-713627503c5b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODh8MHwxfHNlYXJjaHwxfHxza3l3YXklMjBtb25vcmFpbCUyMGZ1dHVyaXN0aWN8ZW58MHx8fHwxNzg0MTQyNDc3fDA&ixlib=rb-4.1.0&q=85',
  },
  {
    id: 2,
    category: 'Partnership',
    date: 'Jul 05, 2025',
    title: 'Strategic partnership signed with three European municipalities',
    excerpt: 'Berlin, Rotterdam and Lyon commit to feasibility studies for full-scale SkyWay integration.',
    image: 'https://images.unsplash.com/photo-1611570266699-4b201348481b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MTN8MHwxfHNlYXJjaHwzfHx1cmJhbiUyMGJyaWRnZXxlbnwwfHx8fDE3ODQxNDI0Nzd8MA&ixlib=rb-4.1.0&q=85',
  },
  {
    id: 3,
    category: 'Technology',
    date: 'Jun 28, 2025',
    title: 'AI Robot v3 completes autonomous cross-city test drive',
    excerpt: 'Onboard robotics adapt to weather, night driving and dynamic passenger loads with 99.98% uptime.',
    image: 'https://images.unsplash.com/photo-1451976426598-a7593bd6d0b2?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxNzV8MHwxfHNlYXJjaHwzfHxncmVlbiUyMHN1c3RhaW5hYmxlJTIwdGVjaG5vbG9neXxlbnwwfHx8fDE3ODQxNDI0ODR8MA&ixlib=rb-4.1.0&q=85',
  },
];

export const roadmap = [
  { year: '2024', title: 'Foundation', desc: 'SkyWay Green ecosystem formed. First prototype line unveiled in test city.' },
  { year: '2025', title: 'Public Launch', desc: 'Commercial line opens, investor portal live, member co-ownership begins.' },
  { year: '2026', title: 'Global Expansion', desc: 'Rollout across 10 metropolitan hubs with connected AI robot fleets.' },
  { year: '2027', title: 'Full Ecosystem', desc: 'Integrated bridges, urban pods, string cargo network and real-estate stakes.' },
];

export const testimonials = [
  {
    id: 1,
    name: 'Amelia Wren',
    role: 'Investor · Amsterdam',
    quote: 'The SkyWay Green ecosystem is the first time I have felt genuinely proud of where my capital sits.',
  },
  {
    id: 2,
    name: 'Mlizy Buttrn',
    role: 'City Planner · Khostova',
    quote: 'Their string rail solution solves elevated transport at a cost profile nothing else on the market can match.',
  },
  {
    id: 3,
    name: 'Sofía Márquez',
    role: 'Sustainability Lead',
    quote: 'Cinematic 3D simulations gave our committee complete clarity - approval in weeks, not years.',
  },
];

export const heroImages = {
  primary: 'https://images.unsplash.com/photo-1557348797-f74d6194faaf?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODh8MHwxfHNlYXJjaHwyfHxza3l3YXklMjBtb25vcmFpbCUyMGZ1dHVyaXN0aWN8ZW58MHx8fHwxNzg0MTQyNDc3fDA&ixlib=rb-4.1.0&q=85',
  secondary: 'https://images.unsplash.com/photo-1564756631354-009c12675629?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1Mjh8MHwxfHNlYXJjaHwzfHxlbGV2YXRlZCUyMHRyYW5zcG9ydHxlbnwwfHx8fDE3ODQxNDI0Nzd8MA&ixlib=rb-4.1.0&q=85',
  tertiary: 'https://images.unsplash.com/photo-1771931527469-be5c7d4a4df6?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1Mjh8MHwxfHNlYXJjaHw0fHxlbGV2YXRlZCUyMHRyYW5zcG9ydHxlbnwwfHx8fDE3ODQxNDI0Nzd8MA&ixlib=rb-4.1.0&q=85',
};
